<template>
  <div class="row pt-0 pt-sm-4 detail-payment-tab-content">
    <div class="col-sm-9 col-md-6 offset-md-3 mb-2">
      <label for="" style="font-size: 20px" class="font-weight-bold">
        Detalles sobre el cobro
      </label>
    </div>

    <div class="col-12 col-md-6 offset-md-3 mpv-sell-price-text">

      <div class="row mb-3">
        <div class="col-8">
            Precio de venta final
        </div>
        <div class="col-4 text-right">
          {{ detailPayment.details.price | currency }}
        </div>
      </div>

      <div v-if="detailPayment.details.ml_fee" class="row mb-3">
        <div class="col-8">
            Comisión MercadoPago
            <TooltipIcon icon="fa fa-question-circle" text="Comisión requerida por mercado libre por el uso de su plataforma" />
        </div>
        <div class="col-4 text-right">
          {{ detailPayment.details.ml_fee | currency }}
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-8">
            Uso de la plataforma
        </div>
        <div class="col-4 text-right">
          {{ detailPayment.details.mpv_fee | currency }}
        </div>
      </div>

      <hr/>

      <div class="row mb-3 font-weight-bold">
        <div class="col-8">
            Recibirás en tu cuenta
        </div>
        <div class="col-4 text-right">
          {{ detailPayment.final.amount | currency }}
        </div>
      </div>
    </div>

    <div class="mx-auto mt-5 mt-lg-3 text-center col-sm-12">
      <SquaredButton
        @click="goToPrice"
        styleType="link"
        label="Anterior" />
      <SquaredButton
        @click="goToConfirmation"
        styleType="primary"
        :label="editingPub ? 'Guardar y continuar' : 'Siguiente'" />
    </div>

  </div>


</template>

<script>
  export default {
    props: {
      detailPayment: {
        type: Object,
      },
    },
    data: () => ({
    }),
    computed: {
      editingPub () {
        return this.$route.name === 'editPublication'
      },
    },
    methods: {
      goToPrice () {
        this.$emit('goToPrice')
      },
      goToConfirmation () {
        this.$emit('goToConfirmation')
      },
    },
  }
</script>

<style lang="scss">
  @import '../../../scss/breakpoints';
  .mpv-tooltip-with-icon {
    &-fig {
      & ~ .tooltip-with-icon-text {
        right: initial;
      }
    }
  }

  .mpv-sell-price-text {
    font-size: 1.1em;
  }

  @media screen and (max-width: map-get($grid-breakpoints, "sm")) {
    .mpv-sell-price-text {
      font-size: .9em;
    }
  }


</style>



// WEBPACK FOOTER //
// src/pages/sellPage/tabs/TabDetailPayment.vue